import { useRef } from 'react'
import { motion, useScroll, useTransform } from 'framer-motion'

// Blend de backgroundColor condus de scroll — pentru tranziții foarte lente între secțiuni.
// `range` controlează cât de „lent": [0.25, 0.6] înseamnă că blendul se petrece
// între 25% și 60% din traversarea wrapper-ului, restul rămâne la `to`.
export default function BgTransition({ from, to, range = [0.25, 0.6], children, className = '' }) {
  const ref = useRef(null)
  // 'start start' → progresul e 0 (deci culoarea = `from`) cât timp topul wrapper-ului
  // (cusătura cu secțiunea de deasupra) e încă în viewport. Încălzirea spre `to` începe
  // abia după ce cusătura iese pe sus => fără linie vizibilă între cele două secțiuni.
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start start', 'end start'],
  })
  const backgroundColor = useTransform(scrollYProgress, range, [from, to])

  return (
    <motion.div ref={ref} style={{ backgroundColor }} className={className}>
      {children}
    </motion.div>
  )
}
